
'use client';

import { ReactNode } from "react";

interface SnackbarProps {
  children: ReactNode;
}

const Snackbar = (props: SnackbarProps) => {
    return (
        <>
        {props.children}
        </>
    );
};

export default Snackbar;


